
export const lotDetailsServicePath = (id, postCode, vrn) => `/connect_api/owner_connect/${id}?zip=${postCode}&vrn=${vrn}`;
export const basicLotDetailsServicePath = (id) => `/connect_api/owner_connect/lot_validation/${id}`
export const fetchLogoServicePath = (seller_company_code) => `/connect_api/owner_connect/seller_logo/${seller_company_code}`
export const callMeServicePath = (id) => `/connect_api/owner_connect/${id}/help_requested`;
export const notMeServicePath = (id) => `/connect_api/owner_connect/${id}/wrong_user`;
export const submitFormServicePath = (id) => `/connect_api/owner_connect/${id}`;
export const GOOGLE_SUGGEST_ADDRESS_URL = (query) => `https://maps.googleapis.com/maps/api/geocode/json?address=${query}&component=country:GB&key=AIzaSyD7nvuhehE7Tgm8LwxAEWnHWSMwxZv5dCQ`;
export const DATE_FORMAT = "DD/MM/YYYY"

export const MAX_INPUT_LENGTH = 50;

export const MIN_ALLOWED_PICKUP_DAY = 2;
export const MAX_ALLOWED_PICKUP_DAY = 5;
export const GOOGLE_ANLYTICS_KEY = 'UA-150648948-2';



// WEBPACK FOOTER //
// ./src/config.uk.js